import Confirm from '@/components/common/Confirm.vue';
import Vue from 'vue';

export default function confirmPlugin() {
  const ConfirmComponent = Vue.extend(Confirm);

  Vue.prototype.$confirm = function confirm(message, title, params = {}) {
    const dialog = new ConfirmComponent({
      parent: this.$root,
      propsData: {
        message,
        title,
        params,
      },
    });
    dialog.$mount();
    document.body.appendChild(dialog.$el);
    dialog.open();

    return new Promise((resolve) => {
      dialog.$once('close', (isAccepted, notes) => {
        document.body.removeChild(dialog.$el);
        resolve({
          confirmed: isAccepted,
          notes,
        });
      });
    });
  };
}
